export const privacy = {
  "privacy.title": "Privacy Policy",
  "privacy.subtitle": "Your privacy is important to us. Learn how we protect your data.",
  "privacy.last_update": "Last update:",
  "privacy.intro_title": "1. Introduction",
  "privacy.data_collection_title": "2. Information we collect",
  "privacy.data_usage_title": "3. How we use your information",
  "privacy.data_sharing_title": "4. Sharing your information",
  "privacy.data_security_title": "5. Data security",
  "privacy.your_rights_title": "6. Your rights",
  "privacy.cookies_title": "7. Cookies",
  "privacy.data_retention_title": "8. Data retention",
  "privacy.international_transfers_title": "9. International transfers",
  "privacy.policy_changes_title": "10. Policy changes",
  "privacy.contact_title": "11. Contact",
  "privacy.provided_info_title": "2.1 Information you provide us",
  "privacy.auto_collected_title": "2.2 Automatically collected information",
  "privacy.cookies_types_title": "Types of cookies used:",
  "privacy.contact_email": "Email:",
  "privacy.contact_address": "Address:",
  "privacy.contact_phone": "Phone:"
};

export default privacy;
